export default {
  data: function data() {
    return {
      reqLoading: false
    };
  },
  methods: {}
};